
define('text!fusion/ui/controls/fusion-link.html',[],function () { return '<a data-bind="attr:{\'href\' : url}, transclude">\r\n</a>';});

